module.exports = __webpack_public_path__ + "static/media/color_lens_white_24dp.09978fcf.svg";